const SermonOutlines = ({thisSermon}) => {

    if (thisSermon.sermonOutline !== 'N/A') {
        let pdfOutline = null;
        if (thisSermon.sermonOutline.indexOf(",") > 0) {
            pdfOutline = "/site/documents/sermon_outlines/" + thisSermon.sermonOutline.split(",")[1];
        } else {
            pdfOutline = "/site/documents/sermon_outlines/" + thisSermon.sermonOutline;
        }
        return (
            <div>
                <strong>Sermon Outline: </strong>
                <a className="underline" href={pdfOutline} rel="noreferrer" target="_blank">
                    <img src="/site/img/icons/pdf.png" alt="Adobe Acrobat PDF format sermon outline"/> PDF Format
                </a>
            </div>
        );
    } else {
        return (
          <p>No Sermon Outlines</p>
        );
    }

};

export default SermonOutlines;